
export const fetchPositiveAndNegativeCardsDataStarted = (state) => {
    return {
        ...state,
        storyboardPositiveAndNegativeData:  {
            isProcessing: true,
            error: false
        }
    }

}

export const fetchPositiveAndNegativeCardsDataSuccess = (state, payload) => {
    let data = payload.payload.data && payload.payload.data.data ? payload.payload.data.data : {}
    let modifiedData = { ...state.storyboardPositiveAndNegativeData.data, [payload.payload.currentId]: data, }
    return {
        ...state,
        storyboardPositiveAndNegativeData:  {
            ...state.storyboardPositiveAndNegativeData,
            data: {
                ...modifiedData,
            },
            isProcessing: Object.keys(modifiedData).length === payload.payload.loadingDetailsData.noOfApiCalls ? false : true,
            error: false
        }
    }

}

export const fetchPositiveAndNegativeCardsDataFailed = (state, payload) => {
    return {
        ...state,
        storyboardPositiveAndNegativeData: {
            isProcessing: false,
            data: null,
            error: true
        },
    }

}